import { differenceInDays } from 'date-fns';
import { BaseService } from './BaseService';
import { ConfigApi } from '../config/Constantes';
import { newDateBr } from '../util/functions';

class ChaveAdmService extends BaseService {
  constructor() {
    super(`${ConfigApi.chaveAdmURL}`);
  }

  async chaveVencimento(body) {
    delete body.id;
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/chaveVencimento`, body);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  async checkProrrogacao(numeroContrato) {
    this.setLoading(true);
    try {
      const response = await this.api.get(
        `${ConfigApi.chaveProrrogacaoURL}?numeroContrato=${numeroContrato}&limit=1`
      );
      if (Array.isArray(response.data.items) && response.data.items.length > 0) {
        const ultimaProrrogacao = response.data.items[0].dataSolicitacao;
        const dateUltimaProrrogacao = newDateBr(ultimaProrrogacao);
        const diferenca = differenceInDays(new Date(), dateUltimaProrrogacao);
        return diferenca <= 20;
      }
      return false;
    } finally {
      this.setLoading(false);
    }
  }

  async contraChaveDispositivo(body) {
    delete body.id;
    this.setLoading(true);
    try {
      const response = await this.api.post(`${this.url}/contraChaveDispositivo`, body);
      return response.data;
    } finally {
      this.setLoading(false);
    }
  }

  getFilter() {
    return new Filter();
  }
}

class Filter {
  constructor() {
    this.limit = 11;
    this.page = 0;
  }
}
export default new ChaveAdmService();
